import { Portal } from '~/components/portal'
import { clsx } from 'clsx'

export const DocumentSidebarPortal = ({
  children,
  className,
  hidden,
}: {
  children?: React.ReactNode
  className?: string
  hidden: boolean
}) => {
  return (
    <Portal id="repo-content-sidebar" className={clsx(className, 'shrink-0')}>
      {hidden ? null : children}
    </Portal>
  )
}
